// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as RestApi$DvmAdminFrontendFr from "../../../../../api/RestApi.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Types$DvmAdminFrontendFr from "./Order_Detail_Bonus_DealerRequest_Types.bs.js";

function fetchDealerRequests(userManager, setResult, selectedRole, orderId) {
  Curry._1(setResult, (function (param) {
          return /* Pending */1;
        }));
  RestApi$DvmAdminFrontendFr.call("GET", Order_Detail_Bonus_DealerRequest_Types$DvmAdminFrontendFr.DealerRequests.requestsList_decode, undefined, userManager, selectedRole, "/flash/bonus/request/" + orderId + "").then(function (result) {
        if (result.TAG === /* OkResult */0) {
          var documents = result._0;
          return Curry._1(setResult, (function (param) {
                        return {
                                TAG: /* Ok */0,
                                _0: documents
                              };
                      }));
        }
        var error = result._0;
        Curry._1(setResult, (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: error
                      };
              }));
      });
}

var Types;

export {
  Types ,
  fetchDealerRequests ,
}
/* RestApi-DvmAdminFrontendFr Not a pure module */
